// Returns
export function convertApiDecimalToString(value, digits = 2, errorValue = undefined) {
    if (typeof value !== 'number') {
        return errorValue;
    }
    return value.toFixed(digits);
}
// Throws on error
export function convertStringToApiDecimal(value) {
    const decimal = typeof value === 'string' && value ? Number(value) : Number.NaN;
    if (isNaN(decimal)) {
        throw new Error(`Invalid string to api decimal conversion: ${value}`);
    }
    return decimal;
}
// FIXME: This function should not exist! It implies German number handling, which causes a lot of problems along the way!
//        Enforce that a number is passed by the API, when a number is needed!
//
// IMPORTANT: Returns the error value, if the value is not a valid number (like '1,23adsf', empty string, undefined or null)
export function dangerouslyParseGermanApiFloat(value, errorValue = Number.NaN) {
    const englishNumber = value?.replace(',', '.');
    if (!englishNumber)
        return errorValue;
    const number = Number(englishNumber);
    return isNaN(number) ? errorValue : number;
}
